import * as React from "react";
import { BOMProgressChart } from "source/app/presentation/MainPanel/Workflows/BookOfMind/Display/ProgressChart/BOMProgressChart";
import { GetBookOfMindNodeIndexAsync } from "source/app/presentation/MainPanel/Workflows/BookOfMind/Helpers/BookOfMindNodeIndex";
import { IBookOfMindState } from "source/app/presentation/MainPanel/Workflows/BookOfMind/Helpers/IBookOfMindState";
import { SetBookOfMindState } from "source/app/presentation/MainPanel/Workflows/BookOfMind/Helpers/BookOfMindHelpers";
import { BookOfMindSearch } from "source/app/presentation/MainPanel/Workflows/BookOfMind/Tools/BookOfMindSearch";
import { BookOfMindTools } from "source/app/presentation/MainPanel/Workflows/BookOfMind/Tools/BookOfMindTools";
import { EGlyphicon } from "source/app/presentation/Shared/Glyphicon/EGlyphicon";
import Glyphicon from "source/app/presentation/Shared/Glyphicon/Glyphicon";
import Hyperlink from "source/app/presentation/Shared/Link/Hyperlink";
import { AddReadingListNode } from "./AddReadingListNode/AddReadingListNode";
import * as styles from "./BookOfMindOptionsPanel.css";

export function BookOfMindOptionsPanel({
    rootNodeName,
    state,
}: {
    rootNodeName: string;
    state: IBookOfMindState;
}) {
    React.useEffect(() => {
        GetBookOfMindNodeIndexAsync().catch(() => undefined);
    }, []);

    return (
        <div className={styles.panel}>
            <div className={styles.contents}>
                <BookOfMindSearch />
                <div className={styles.heading}>
                    <span>Reading list</span>
                    <span className={styles.count}>
                        {state.readingListNodeNames.length}{" "}
                        {state.readingListNodeNames.length === 1
                            ? "node"
                            : "nodes"}{" "}
                        in collection
                    </span>
                </div>
                {state.readingListNodeNames.map((nodeName) => (
                    <div className={styles.node} key={nodeName}>
                        <span>{nodeName}</span>
                        <button
                            type="button"
                            className={styles.removeButton}
                            disabled={
                                state.readingListNodeNames.length === 1
                            }
                            onClick={() =>
                                SetBookOfMindState({
                                    readingListNodeNames:
                                        state.readingListNodeNames.filter(
                                            (name) => name !== nodeName
                                        ),
                                })
                            }
                        >
                            - Remove
                        </button>
                    </div>
                ))}
                <AddReadingListNode state={state} />
                <div className={styles.progressSection}>
                    <BOMProgressChart />
                </div>
                <BookOfMindTools rootNodeName={rootNodeName} state={state} />
            </div>
        </div>
    );
}

export function BookOfMindOptionsButton({
    isOpen,
    onClick,
}: {
    isOpen: boolean;
    onClick: () => void;
}) {
    return (
        <div
            className={`${styles.footerPanel} ${
                isOpen ? styles.footerPanel_open : ""
            }`}
        >
            <Hyperlink whenClicked={onClick}>
                <Glyphicon icon={EGlyphicon.cog} />
                <Glyphicon
                    icon={
                        isOpen
                            ? EGlyphicon["chevron-down"]
                            : EGlyphicon["chevron-up"]
                    }
                />
            </Hyperlink>
        </div>
    );
}
